module.exports = require("core-js/library/fn/object/values");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/object/values.js
// module id = 25
// module chunks = 0